import { render, staticRenderFns } from "./CreateFacebookAds.vue?vue&type=template&id=6f60907e&scoped=true&"
import script from "./CreateFacebookAds.vue?vue&type=script&lang=js&"
export * from "./CreateFacebookAds.vue?vue&type=script&lang=js&"
import style0 from "./CreateFacebookAds.vue?vue&type=style&index=0&id=6f60907e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f60907e",
  null
  
)

export default component.exports